import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { finalize } from 'rxjs/operators';
import { DocumentService } from 'src/app/core/services/document.service';

export interface NoteDialogData {
  contractId: string;
}

@Component({
  selector: 'app-note-dialog',
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.scss']
})
export class NoteDialogComponent implements OnInit {
  notes: string[] = [];
  isLoading = false;
  errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<NoteDialogComponent>,
    private documentService: DocumentService,
    @Inject(MAT_DIALOG_DATA) public data: NoteDialogData
  ) {}

  ngOnInit(): void {
    this.fetchNotes();
  }

  fetchNotes(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.documentService.getStandardizedNotes(this.data.contractId)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe(
        (res: any) => {
          this.notes = Array.isArray(res && res.data) ? res.data : [];
        },
        () => {
          this.errorMessage = 'labor_contract_standardize.note_dialog.load_error';
        }
      );
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
